import { render, staticRenderFns } from "./ConsultaInstalacionesPantalla.vue?vue&type=template&id=b2871f52&"
import script from "./ConsultaInstalacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConsultaInstalacionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports